document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-fbt-section]');

  sections.forEach(function (section) {
    var wrap = section.querySelector('.fbt-scroll-wrap');
    var track = section.querySelector('[data-fbt-track]');
    var prevBtn = section.querySelector('[data-fbt-prev]');
    var nextBtn = section.querySelector('[data-fbt-next]');
    var addButtons = section.querySelectorAll('[data-fbt-add]');

    // --- Scroll pijlen: alleen tonen als er echt overflow is ---
    function updateArrows() {
      var hasOverflow = track.scrollWidth > track.clientWidth + 4;
      wrap.classList.toggle('has-overflow', hasOverflow);

      if (!hasOverflow) return;

      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    function scrollByCard(direction) {
      var card = track.querySelector('.fbt-card-item');
      if (!card) return;
      var cardWidth = card.getBoundingClientRect().width + 16; // + gap
      track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      nextBtn.addEventListener('click', function () { scrollByCard(1); });
      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    // --- Snel toevoegen aan winkelwagen ---
    addButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.classList.contains('is-loading')) return;

        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        button.classList.add('is-loading');

        fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (err) {
                throw new Error(err.description || 'Kon product niet toevoegen');
              });
            }
            return response.json();
          })
          .then(function () {
            button.classList.remove('is-loading');
            button.classList.add('is-added');

            // Cello/Dawn: bestaande cart drawer verversen en openen.
            // Pas 'cart:refresh' hieronder aan naar de event-naam die het thema
            // al gebruikt als dit niet automatisch de drawer bijwerkt/opent.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            setTimeout(function () {
              button.classList.remove('is-added');
            }, 1800);
          })
          .catch(function (error) {
            button.classList.remove('is-loading');
            console.error('Vaak samen gekocht - toevoegen mislukt:', error);
          });
      });
    });
  });
});